import type { User } from "@/users/types";
import { apiClient } from "./apiClient";

export const usersGateway = {
  async listUsers(): Promise<Array<User>> {
    return await apiClient.get("/api/users");
  },

  async getUser(id: string): Promise<User> {
    return await apiClient.get(`/api/users/${id}`);
  },

  async updateUser(user: User): Promise<User> {
    return await apiClient.put(`/api/users/${user.id}`, user);
  },

  async deleteUser(user: User): Promise<void> {
    return await apiClient.delete(`/api/users/${user.id}`);
  },

  async deleteSelf(): Promise<void> {
    return await apiClient.delete("/api/users/me");
  },
};
